'use client';

import { Grid, Stack, useMediaQuery, useTheme, Typography } from '@mui/material';
import Image from 'next/image';
export const ProfitCard = ({
  title,
  image,
  subtitle
}: {
  title: string;
  image: string;
  subtitle: string;
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return <Stack maxWidth={232} gap={2} padding={2} borderRadius={4} alignItems='center' sx={{
    border: '1px solid',
    borderColor: 'tertiary.main',
    '&:hover': {
      boxShadow: '0px 8px 12px 8px rgba(226, 108, 43, 0.10)'
    }
  }} data-sentry-element="Stack" data-sentry-component="ProfitCard" data-sentry-source-file="WhySignup.tsx">
      <Typography fontSize={{
      xs: 14,
      md: 18
    }} fontWeight={700} data-sentry-element="Typography" data-sentry-source-file="WhySignup.tsx">
        {title}
      </Typography>
      <Image width={isSmallScreen ? 104 : 160} height={isSmallScreen ? 104 : 160} src={image} alt={title} data-sentry-element="Image" data-sentry-source-file="WhySignup.tsx" />
      <Typography fontSize={{
      xs: 12,
      md: 16
    }} fontWeight={500} data-sentry-element="Typography" data-sentry-source-file="WhySignup.tsx">
        {subtitle}
      </Typography>
    </Stack>;
};
export const WhySignup = () => {
  const text = {
    title: 'چرا باید در',
    highlight: 'زیما ثبت‌نام کنم؟',
    subtitle: 'هم‌اکنون ثبت‌نام کنید، به جمع سرمایه‌گذاران بپیوندید و ۵ سوت طلا هدیه بگیرید.'
  };
  return <Stack gap={5} data-sentry-element="Stack" data-sentry-component="WhySignup" data-sentry-source-file="WhySignup.tsx">
      <Stack sx={{
      display: {
        xs: 'none',
        md: 'flex'
      }
    }} gap={2} data-sentry-element="Stack" data-sentry-source-file="WhySignup.tsx">
        <Typography fontSize={32} fontWeight={700} data-sentry-element="Typography" data-sentry-source-file="WhySignup.tsx">
          {text.title}
          <strong className='highlight-primary'> {text.highlight}</strong>
        </Typography>
        <Typography fontSize={24} fontWeight={500} data-sentry-element="Typography" data-sentry-source-file="WhySignup.tsx">
          {text.subtitle}
        </Typography>
      </Stack>
      <Grid container columnSpacing={3} rowSpacing={3} alignItems='center' textAlign='center' data-sentry-element="Grid" data-sentry-source-file="WhySignup.tsx">
        <Grid item xs={6} sm={6} md={3} data-sentry-element="Grid" data-sentry-source-file="WhySignup.tsx">
          <ProfitCard title='سودآوری هوشمندانه' subtitle='افزایش سرمایه در پروژه‌های واقعی، بازدهی پیش‌بینی شده' image='/images/home/profitability.webp' data-sentry-element="ProfitCard" data-sentry-source-file="WhySignup.tsx" />
        </Grid>
        <Grid item xs={6} sm={6} md={3} data-sentry-element="Grid" data-sentry-source-file="WhySignup.tsx">
          <ProfitCard title='سرمایه‌گذاری مطمئن' subtitle='بازپرداخت اصل سرمایه با پشتوانه ضمانت بانکی.' image='/images/home/investment.webp' data-sentry-element="ProfitCard" data-sentry-source-file="WhySignup.tsx" />
        </Grid>
        <Grid item xs={6} sm={6} md={3} data-sentry-element="Grid" data-sentry-source-file="WhySignup.tsx">
          <ProfitCard title='حمایت از کسب‌وکارها' subtitle='سرمایه‌گذاری در مسیر رشد کسب‌وکارها و رشد اقتصادی.' image='/images/home/support.webp' data-sentry-element="ProfitCard" data-sentry-source-file="WhySignup.tsx" />
        </Grid>
        <Grid item xs={6} sm={6} md={3} data-sentry-element="Grid" data-sentry-source-file="WhySignup.tsx">
          <ProfitCard title='هدیه ثبت‌نام' subtitle='دریافت ۵ سوت طلا به عنوان امتیاز اولیه عضویت' image='/images/home/gift.webp' data-sentry-element="ProfitCard" data-sentry-source-file="WhySignup.tsx" />
        </Grid>
      </Grid>
    </Stack>;
};